module.exports = __webpack_public_path__ + "assets/img/check.93ded15a.svg";